module.exports = __webpack_public_path__ + "static/media/Гермидер О., Попов В. (НУ).fc8f5215.pdf";